import React from "react";
import "./AceSelector.css";
import TableGrid from "../../common/components/TableGrid/tableGrid";
import { aceAlertsSelectorColumns } from "../../common/components/TableGrid/tableColumn/AceAlertsSelectorColumns";
import InputSearch from "../../common/components/Search/InputSearch";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import { apiUri } from "../../config";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";

const AceSelector = (props) => {
  const columns = aceAlertsSelectorColumns(props);

  const handleAddCompany = () => {
    Axios.get(`${apiUri}/cases/getUserId`)
      .then((response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data.content &&
          response.data.content.userExisted
        ) {
          props.history.push({
            pathname: "/addCompany",
            state: {
              user: { registrationUuid: response.data.content.registrationId },
            },
          });
        }
      })
      .catch((error) => {
        console.log("error", error);
        NotificationManager.error(error.message, "Failure");
      });
  };

  return (
    <React.Fragment>
      <div className={"CaseSelectorTitle dandO_titleblock"}>
        <div
          className="dandO_title_item"
          id={"commission-selector-title-holder"}
        >
          <div className={"commission-selector-title"}>ACE Alert&reg; Subscriptions</div>
        </div>
        <div className="dandO_title_item">
          <div className="dandO_search_block">
            {/* { props.firmSettings.alert &&
						<Link to={"/dandos/create"}>
							<button id={"commission-create-commission-button"}>Create Risk Assessment</button>
						</Link>
					} */}
            <InputSearch
              handleSearch={props.handleSearch}
              handleClear={props.handleClear}
            />
            <button
              className="sar-btn"
              style={{ margin: "0px" }}
              onClick={handleAddCompany}
            >
              Add Company
            </button>
          </div>
        </div>
      </div>
      <TableGrid
        columns={columns}
        data={props.aceAlerts || []}
        handleSort={props.handleSort}
        sortValue={props.sortValue}
        sortOrder={props.sortOrder}
      />
      <NotificationContainer />
    </React.Fragment>
  );
};

export default withRouter(AceSelector);



// WEBPACK FOOTER //
// ./src/ace/components/AceSelector.js